$(function(){
  initflickityRecommendation();
  initflickityfeatcol();
  initFlickity();
  setAnnouncementListItemHeight();
  closeBoostSearchForm();
  registerChildContainerToggle();
});

openSizeGuide = () =>{
  $('.jsc-popup-sizeGuide-overlay').show();
  $('.jsc-popup-sizeGuide').show();
}

closeSizeGuide = () =>{
  $('.jsc-popup-sizeGuide-overlay').hide();
  $('.jsc-popup-sizeGuide').hide();
}

comoTag = (evt) =>{
  setTimeout(function(){
    var tagComo = "COMO No:" + $(evt).val();
    $('#COMO-clubber-number').val(tagComo);
  }, 10);
}

comoinputOpen = (evt) =>{
  $('.jsc-comoClubField').show();
  $('.jsc-comoClubFieldEdit').hide();
}

//start: initiate the carousel of pdp recommendations section
initflickityRecommendation = () => {
  var timesRun = 0;
  var countGrid = 0;
    var timer = setInterval(function() {

      if (($(window).width() > 481) && ($(window).width() < 825)) {
        if ($('.jsc-recommendation-flickity').length > 0 ) {

              var flkty = new Flickity( '.jsc-recommendation-flickity' , {
                // options
                cellAlign: 'center',
                contain: true,
                pageDots: false,
                groupCells: true,
                wrapAround: false,
                draggable: true,
                prevNextButtons: false,
                //autoPlay: 5000,
                on: {
                  ready: function() {
                    $(this.element).addClass('jsc-flickity-initiated');
                  }
                }
              });

          }

          clearInterval(timer);
      }

    }, 800);

}
//end: initiate the carousel of pdp recommendations section

//start: initiate the carousel of featured collections section
initflickityfeatcol = () => {
  $('.jsc-featCol-carousel').each(function(){
    var flkty = new Flickity( this , {
      // options
      cellAlign: 'left',
      contain: true,
      wrapAround: false,
      pageDots: false,
      prevNextButtons: true,
      groupCells: true,
      freeScroll: true,
      on: {
        ready: function() {
          $(this.element).addClass('jsc-flickity-initiated-featCol');
        }
      }
    });
  });
}
//end: initiate the carousel of featured collections section

// giftcard recipient - Start
giftCardrecipient = (evt) => {
  $('.jsc-email-error').hide();
  if ($(evt).prop('checked') == true) {
      $('.recipient-fields').show();
      $('.email.field__input').attr('name','properties[Recipient email]');
      $('.name.field__input').attr('name','properties[Recipient name]');
      $('.text-area.field__input').attr('name','properties[Message]');
      $('.date.field__input').attr('name','properties[Send on]');
      $('.recipiendtcontrol').attr('name','properties[__shopify_send_gift_card_to_recipient]');
  }else{
      $('.recipient-fields').hide();
      $('.email.field__input').removeAttr('name');
      $('.name.field__input').removeAttr('name');
      $('.text-area.field__input').removeAttr('name');
      $('.date.field__input').removeAttr('name');
      $('.recipiendtcontrol').removeAttr('name');
  }
}
// giftcard recipient - End

initFlickity = () => {
  var $width = $(window).width();
  var $collection_list = $('ul.collection__list');
  var $collection_list_items = $('ul.collection__list li');
  var $cells = $collection_list.data('collection-size');
  var $animation_time = $collection_list.data('animation-time');
  if (($width >= 1023.98 && $cells > 8) || ($width < 1023.98 && $cells > 6) || $width < 768) {
    $collection_list.addClass('carousel');
    $collection_list_items.each(function() {
      $(this).addClass('carousel-cell');
    });

    var $carousel = $('.carousel');
    if (!$carousel.data('flickity')) {
      $carousel.flickity({
        groupCells: 2,
        cellAlign: 'center',
        contain: true,
        pageDots: false,
        wrapAround: false,
        prevNextButtons: true,
        autoPlay: $animation_time
      });
    }
  } else {
    var $carousel = $('.carousel');
    if ($carousel.data('flickity')) {
      $carousel.flickity('destroy').removeData('flickity');
    }
    $collection_list.removeClass('carousel');
    $collection_list_items.each(function() {
      $(this).removeClass('carousel-cell');
    });
  }
}

window.onresize = initFlickity;
//start: show shop the look hotspot product
showItem = (e, isOpen) => {
  var item = $(e).data('item');
  if ($(`#${item}`).length > 0) {
    if (isOpen) {
      $(`#${item}`).removeClass('d-none');
    } else {
      $(`#${item}`).addClass('d-none');
    }
  }
}
//end: show shop the look hotspot product

//start: pairs well with
selectAddOns = (e) =>{
  var _this = $(e);

  var pww_product = _this.closest('.jsc-add-ons');
  var variant_picker = _this.closest('.variant-picker').data('options');
  var options = variant_picker.split(',');
  var findVariantID = false;
  var value = '';
  $.each(options, function(index, option) {
    if(option != '') {
      var option_value = _this.closest('.variant-picker').find(`select[name="${option}"]`).val();

      if (index === options.length - 2) {
        value = value + option_value;
      } else {
        value = value + option_value + ' / ';
      }

      if (option_value === '') {
        findVariantID = false;
        return false;
      } else {
        findVariantID = true;
      }
    }
  });

  if (findVariantID) {
    vID(_this, value);
    pww_product.addClass('active');
  }
}

vID = (parentSelector, optionVal) => {
  var options = $(parentSelector).closest('.variant-picker').find('select[name="id"] option');
  var optionValue = '';

  options.each(function(index, option) {
    var innerHTML = $(option).html();
    if (innerHTML.includes(optionVal)) {
      optionValue = $(option).val();
      console.log('optionValue: ', optionValue);
      $(parentSelector).closest('.variant-picker').find('input[name="pww_variant"]').val(optionValue);
    }
  });
};

addPWW = (e, vid) =>{
  var _this = $(e);
  var _activeSelection = $('.jsc-add-ons.active');
  var itemsArray = [];
  var error = 'error:';

  _activeSelection.each(function(){
    var _active = $(this);
    var _title = _active.find('indiv-product-title-text').text();
    var _vid = _active.find('input[name="pww_variant"]').val();
    var _quantity = _active.find('input[name="quantity"]').val();

    console.log('_vid: ', _vid);
    console.log('_quantity: ', _quantity);
    if (_vid.includes('Sold Out')) {
      error = `${error} ${_title} ${_vid} `;
    }
    var _objs = {
      id: _vid,
      quantity: _quantity
    }
    itemsArray.push(_objs);
  });

  if (itemsArray.length > 0) {
    CartJS.addItems(itemsArray);

    $(document).on('cart.requestComplete', function(event, cart) {
      console.log('cart.requestComplete event fired');
      _this.siblings('#purchase').click();
      _this.text('Added');
      if (error != 'error:') {
        $('<div id="cart-error"></div>').addClass('alert alert-danger').text(error).insertAfter(_this.siblings('#purchase'));
      }
      setTimeout(() => {
        _this.text('Add to cart');
      }, 3000);
    });
  } else {
    _this.siblings('#purchase').click();
  }
}
//end: pairs well with
//start: remove cart item
updateCartItems = (e, _itemKey, isGiftWrap, minus, isAssemblyRequired) => {
  var update_qty = 1;
  var obj = {};

  if (!isNaN(e)) {
    update_qty = e;
  } else if ($(e).length > 0) {
    update_qty = $(e).closest('tr').find('.cart-table-quantity input[name="updates[]"]').val(); // main product qty
  }

  var main_product = _itemKey;
  var main_qty = update_qty;
  if (isNaN(e) && $(e).length > 0) {
    main_qty = 0;
  }
  obj[main_product] = main_qty;

  if ((isGiftWrap != '' && isGiftWrap == 'Yes') || (isAssemblyRequired != '' && isAssemblyRequired == 'Yes')) {
    var gift_wrap_id = 44432684024085;
    var assembly_cost_id = 49137297457429;

    jQuery.getJSON('/cart.js', function(cart) {
      var items = cart.items;
      $.each(items, function(index, item){
        if (item.id == gift_wrap_id) {
          if (!isNaN(e) && minus) {
            var gift_wrap_qty = item.quantity - 1;
          } else if (!isNaN(e) && !minus) {
            var gift_wrap_qty = item.quantity + 1;
          } else {
            var gift_wrap_qty = item.quantity - update_qty;
          }

          if (gift_wrap_qty < 0) {
            gift_wrap_qty = 0
          }
          obj[gift_wrap_id] = gift_wrap_qty;
        } else if (item.id == assembly_cost_id) {
          if (!isNaN(e) && minus) {
            var assembly_cost_qty = item.quantity - 1;
          } else if (!isNaN(e) && !minus) {
            var assembly_cost_qty = item.quantity + 1;
          } else {
            var assembly_cost_qty = item.quantity - update_qty;
          }

          if (assembly_cost_qty < 0) {
            assembly_cost_qty = 0
          }
          obj[assembly_cost_id] = assembly_cost_qty;
        }
      });
      CartJS.updateItemQuantitiesById(obj);
    });
  } else {
    CartJS.updateItemQuantitiesById(obj);;
  }

  $(document).on('cart.requestComplete', function(event, cart) {
    location.reload();
  });
}
//end:remove cart item

setAnnouncementListItemHeight = () => {
  var parentElement = $('.announcement-slides');
  var maxHeight = 0;

  parentElement.children().each(function() {
    var childHeight = $(this).outerHeight();
    if (childHeight > maxHeight) {
        maxHeight = childHeight;
    }
  });

  parentElement.children().each(function() {
    $(this).css('height', `${maxHeight}px`);
  });
}
$(window).resize(function() {
  setAnnouncementListItemHeight();
})
closeBoostSearchForm = () => {
  $(document).on('click', 'button[data-group="close-search-form"]', function () {
    if ($(window).width() <= 992) {
      $('#top-search-wrapper').removeClass('expanded');
    }
  });
}
registerChildContainerToggle = () => {
  // Check if elements already exist
  const $containers = $(".cf-field-container.register-child-container");
  if ($containers.length > 0) {
    initializeChildContainerToggle();
    return;
  }

  // Watch for DOM changes
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        const $containers = $(".cf-field-container.register-child-container");
        if ($containers.length > 0) {
          observer.disconnect(); // Stop observing once found
          initializeChildContainerToggle();
        }
      }
    });
  });

  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

initializeChildContainerToggle = () => {
  const $containers = $(".cf-field-container.register-child-container");
  console.log("registerChildContainerToggle: ", $containers);

  // Use delegated event binding
  $(document).off("click", ".cf-field-container.register-child-container").on("click", ".cf-field-container.register-child-container", function() {
    const $container = $(this);

    for (let i = 1; i <= 4; i++) {
      if ($container.hasClass("register-child-" + i)) {
        console.log("Clicked on child:", i, $(".cf-field-container.register-child-" + i + "-field"));
        $container.toggleClass('hide-child');
        $(".cf-field-container.register-child-" + i + "-field").toggleClass('hide-child');
      }
    }
  });
}
// ================================
// Constants
// ================================
const gift_wrap_variant_id = 44432684024085;

// ================================
// Sync gift wrap item with cart (checkout only)
// ================================
function syncGiftWrapForCheckout(callback) {
  $.getJSON('/cart.js', function(cart) {

    // Calculate total items that need gift wrap
    const totalGiftWrapNeeded = cart.items
      .filter(i => i.properties && i.properties.gift_wrap === "Yes")
      .reduce((sum, i) => sum + i.quantity, 0);

    // Find gift wrap item in cart
    const giftWrapItem = cart.items.find(i => i.id == gift_wrap_variant_id);

    // Gift wrap needed but not in cart → add it
    if (!giftWrapItem && totalGiftWrapNeeded > 0) {
      CartJS.addItems([{ id: gift_wrap_variant_id, quantity: totalGiftWrapNeeded }], {
        "success": () => callback(),
        "error": () => callback()
      });
      return;
    }

    // Gift wrap exists but quantity mismatch → update it
    if (giftWrapItem && giftWrapItem.quantity !== totalGiftWrapNeeded) {
      CartJS.updateItemQuantitiesById({ [giftWrapItem.id]: totalGiftWrapNeeded }, {
        "success": () => callback(),
        "error": () => callback()
      });
      return;
    }

    // Already synced → proceed
    callback();
  });
}
checkoutRedirect = (e) => {
  console.log("checkoutRedirect:");
  const _this = $(e);

  // Find the terms checkbox relative to checkout button
  const termsAgreeCheckbox = _this
    .closest('#checkout-buttons')
    .siblings('.terms-conditions')
    .find('input[id="agree"]')
    .prop('checked');
  console.log("termsAgreeCheckbox: ", termsAgreeCheckbox);

  if (termsAgreeCheckbox) {
    syncGiftWrapForCheckout(function() {
      // After sync, submit checkout
      window.location.href = "/account/login?return_to=/checkout";
    });
  } else {
    alert("You must agree with the terms and conditions of sales to check out.");
  }
};
// ================================
// Checkout button interception
// ================================
$(document).ready(function() {
  $('#cart_submit').on('click', function(e) {
    e.preventDefault();

    syncGiftWrapForCheckout(function() {
      // After sync, submit checkout
      window.location.href = '/checkout';
    });
  });
});
// #16972 - Round PDP / JS money formatting to nearest dollar (no .00 / .50)
(function patchThemeFormatMoney() {
  function roundCents(cents) {
    var value = cents;
    if (typeof value === 'string') {
      value = value.replace('.', '');
    }
    value = Number(value);
    if (isNaN(value)) return cents;
    return Math.round(value / 100) * 100;
  }

  function stripTrailingZeros(html) {
    if (typeof html !== 'string') return html;
    return html.replace(/(\d+)\.00(?!\d)/g, '$1');
  }

  function tryPatch() {
    if (!window.wetheme || typeof window.wetheme.formatMoney !== 'function') {
      return false;
    }
    if (window.wetheme.__jscRoundMoneyPatched) return true;

    var original = window.wetheme.formatMoney.bind(window.wetheme);
    window.wetheme.formatMoney = function (cents, format) {
      return stripTrailingZeros(original(roundCents(cents), format));
    };
    window.wetheme.__jscRoundMoneyPatched = true;
    return true;
  }

  if (!tryPatch()) {
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (tryPatch() || tries > 40) clearInterval(timer);
    }, 250);
  }
})();
